import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgUserFilledIcon = function SvgUserFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6cf817a-0093-4c07-a48e-4452ffe0388b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 43.2",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18,21.6A10.8,10.8,0,1,0,7.2,10.8,10.79,10.79,0,0,0,18,21.6ZM32.14,43.2A3.86,3.86,0,0,0,36,39.34V36A10.81,10.81,0,0,0,25.2,25.2H23.86a14,14,0,0,1-11.72,0H10.8A10.81,10.81,0,0,0,0,36v3.34A3.86,3.86,0,0,0,3.86,43.2Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }));
};

export { SvgUserFilledIcon as ReactComponent };
